import { useCallback, useEffect, useState } from 'react'
import { supabase } from '../../services/supabase'
import type { SimpleHqRole } from './constants'
import { SIMPLE_HQ_COMPANY_ID } from './constants'

export type SimpleHqAccess = {
  loading: boolean
  role: SimpleHqRole | null
  companyId: string
  isMember: boolean
  isApprover: boolean
  isHqAdmin: boolean
  refresh: () => Promise<void>
}

export function useSimpleHqAccess(): SimpleHqAccess {
  const [loading, setLoading] = useState(true)
  const [role, setRole] = useState<SimpleHqRole | null>(null)
  const [companyId, setCompanyId] = useState(SIMPLE_HQ_COMPANY_ID)

  const refresh = useCallback(async () => {
    setLoading(true)
    try {
      const { data: cid } = await supabase.rpc('simple_hq_company_id')
      if (typeof cid === 'string' && cid) setCompanyId(cid)

      const { data: ensured, error } = await supabase.rpc('ensure_simple_hq_member')
      if (error) {
        console.warn('ensure_simple_hq_member', error.message)
        setRole(null)
        return
      }
      const r = (ensured as SimpleHqRole | null) || null
      setRole(r)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return {
    loading,
    role,
    companyId,
    isMember: !!role,
    isApprover: role === 'admin' || role === 'delegate',
    isHqAdmin: role === 'admin',
    refresh,
  }
}
